import { NgIf } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { RippleDirective } from '../../ripple.directive';

export interface IDialogData {
  title: string;
  titleIcon?: string;
  messageIcon?: string;
  message?: string;
  hideCancelButton?: boolean;
  hideConfirmButton?: boolean;
  confirmButtonText?: string;
  image?: string;
  imageTitle?: string;
}

@Component({
  selector: 'app-kyloe-confirm-dialog',
  templateUrl: './kyloe-confirm-dialog.component.html',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    RippleDirective,
    RippleDirective,
    NgIf,
    MatTooltip,
    MatButton,
  ],
  styleUrls: ['./kyloe-confirm-dialog.component.scss']
})
export class KyloeConfirmDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<KyloeConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.data.confirmButtonText = this.data.confirmButtonText ? this.data.confirmButtonText : 'Yes';
  }
}
